module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_20.dot-76951d4a3c93065a2cb5ff6a7803566f.svg";